import { useTranslation } from 'react-i18next';

import { ChangeGroup, ChangeRole } from '@/component';
import { USER_CONST } from '@/constant';
import { AccountCircle, Close, VFlex, VInput, VStack } from '@/package';
import { useAuthStore } from '@/store';
import type { User, UserGroup } from '@/type';

type UserProfileProps = {
  closeMemberProfile: () => void;
  groupList?: UserGroup[];
  selectedUser: Nullish<User>;
};

const UserProfile = ({
  closeMemberProfile,
  groupList,
  selectedUser,
}: UserProfileProps) => {
  const { t } = useTranslation();
  const me = useAuthStore(state => state.user);
  const isUserEditable =
    !(
      me.role === USER_CONST.USER_ROLE.MANAGER ||
      me.role === USER_CONST.USER_ROLE.WORKER ||
      me.role === USER_CONST.USER_ROLE.GUEST
    ) && selectedUser?.role !== USER_CONST.USER_ROLE.GUEST;

  return (
    <VStack className="gap-[40px] px-8 py-6">
      <VFlex justify="between" className="w-full" items="center">
        <div className="text-headline-md">
          {t('user.memberProfile.cacotheline')}
        </div>
        <Close
          role="button"
          className="h-6 w-6 text-gray-400"
          onClick={closeMemberProfile}
        />
      </VFlex>
      <VFlex gap={1.5} className="w-full">
        <AccountCircle className="h-[184px] w-[184px]" />
        <VStack className="flex-1" gap={2.5}>
          <VStack className="flex-1" gap={1}>
            <VInput
              label="Name"
              value={selectedUser?.name || selectedUser?.email.split('@')[0]}
              readOnly={isUserEditable}
            />
            <VInput
              label="Email"
              value={selectedUser?.email ?? ''}
              readOnly={isUserEditable}
            />
            {groupList && (
              <ChangeRole
                selectedUser={selectedUser!}
                isUserEditable={isUserEditable}
              />
            )}
            {groupList && (
              <ChangeGroup
                groupList={groupList}
                selectedUser={selectedUser!}
                isUserEditable={isUserEditable}
              />
            )}
          </VStack>
        </VStack>
      </VFlex>
    </VStack>
  );
};

export default UserProfile;
